var map = {
	"./alga1.jpg": 80,
	"./alga1_lut.jpg": 81,
	"./alga2.jpg": 82,
	"./alga2_lut.jpg": 83,
	"./alga3.jpg": 84,
	"./alga3_lut.jpg": 85,
	"./area.jpg": 86,
	"./bolsas.jpg": 87,
	"./calidad.jpg": 30,
	"./contacto.jpg": 51,
	"./container.jpg": 39,
	"./donde.jpg": 40,
	"./equipo.jpg": 88,
	"./especificaciones.jpg": 52,
	"./export.svg": 37,
	"./icons/404.svg": 26,
	"./icons/barco.svg": 48,
	"./icons/equis.svg": 27,
	"./icons/facebook.svg": 19,
	"./icons/instagram.svg": 34,
	"./icons/linkedin.svg": 20,
	"./icons/pescador.svg": 49,
	"./icons/proceso.svg": 50,
	"./icons/sandwich.svg": 28,
	"./icons/whatsapp.svg": 29,
	"./infraestructura.jpg": 53,
	"./logo_op1.svg": 89,
	"./logo_op1_white.svg": 24,
	"./logo_op2.svg": 38,
	"./mano.jpg": 35,
	"./materia_prima1.jpg": 90,
	"./materia_prima2.jpg": 91,
	"./materia_prima3.jpg": 92,
	"./pescador.jpg": 36,
	"./procesamiento.jpg": 41,
	"./producto.jpg": 93,
	"./quienes.jpg": 42,
	"./suelo1.jpg": 43,
	"./suelo2.jpg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;